
import MainLayout from "@/components/layout/MainLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Brain, TrendingUp, Users, Zap } from "lucide-react";
import PageSEO from "@/components/seo/PageSEO";

const AdvancedAnalysis = () => {
  const features = [
    {
      icon: Brain,
      title: "Análise Cognitiva Profunda",
      description: "Insights detalhados sobre padrões de pensamento e comportamento baseados em IA avançada."
    },
    {
      icon: TrendingUp,
      title: "Previsões de Bem-estar",
      description: "Algoritmos preditivos que antecipam tendências de humor e recomendam ações preventivas."
    },
    {
      icon: Users,
      title: "Comparações Populacionais",
      description: "Compare seu perfil com dados anonimizados de usuários similares para contextualização."
    },
    {
      icon: Zap,
      title: "Insights em Tempo Real",
      description: "Análises instantâneas que se adaptam aos seus dados mais recentes automaticamente."
    }
  ];

  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://metrocalma.org/app"
    },
    {
      position: 2,
      name: "Análise Avançada",
      item: "https://metrocalma.org/analise-avancada"
    }
  ];

  const structuredData = {
    "@type": "Service",
    "name": "Análise Avançada metrocalma",
    "description": "Análises psicológicas avançadas com inteligência artificial para insights profundos sobre personalidade e bem-estar mental.",
    "provider": {
      "@type": "Organization",
      "name": "metrocalma"
    },
    "serviceType": "Mental Health Analysis Service",
    "areaServed": "BR",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Serviços de Análise Avançada",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Análise Cognitiva Profunda"
          }
        },
        {
          "@type": "Offer", 
          "itemOffered": {
            "@type": "Service",
            "name": "Previsões de Bem-estar"
          }
        }
      ]
    }
  };

  return (
    <MainLayout>
      <PageSEO 
        title="Análise Avançada - metrocalma | IA para Insights Psicológicos Profundos"
        description="Obtenha análises psicológicas avançadas com inteligência artificial. Insights profundos sobre personalidade, padrões comportamentais e previsões de bem-estar personalizadas."
        canonicalUrl="https://metrocalma.org/analise-avancada"
        keywords="análise avançada, IA psicologia, insights comportamentais, análise personalidade, previsões bem-estar, inteligência artificial"
        pageName="Análise Avançada"
        pageType="Service"
        structuredData={structuredData}
        breadcrumbs={breadcrumbs}
      />
      
      <div className="container mx-auto py-8">
        <div className="mb-8">
          <Card>
            <CardHeader className="text-center">
              <Badge className="w-fit mx-auto mb-4" variant="secondary">
                Powered by AI
              </Badge>
              <CardTitle className="text-3xl">Análise Avançada</CardTitle>
              <CardDescription className="text-lg">
                Desbloqueie insights profundos sobre sua mente com nossa tecnologia de IA avançada
              </CardDescription>
            </CardHeader>
          </Card>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {features.map((feature, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <feature.icon className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl">{feature.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="mt-8">
          <CardHeader className="text-center">
            <CardTitle>Pronto para começar?</CardTitle>
            <CardDescription>
              Complete pelo menos um teste de personalidade para acessar análises avançadas
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center">
            <Button size="lg" className="px-8">
              Explorar Análises
            </Button>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default AdvancedAnalysis;
